export class PagedResponse<T> {

    public items: T[];
    public total: number;

    constructor() {
        this.items = []
        this.total = 0
    }
}
